// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"Uf","place_order_copy":"Vf","next_order_copy":"Wf","title_wrapper":"Xf","get_it_now_row":"Yf","get_it_now_remaining_items":"Zf","get_it_now_remaining_items_mob":"ag","order_summary":"bg","additional_items":"cg","account_content_slider":"eg","ingredient_carousel":"fg","ingredient_carouselwrapper":"gg","account_content_slide":"hg","account_subscription_section_mob":"ig","carouselwrapper":"jg"};
    if(module.hot) {
      // 1715188223384
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  